"use client"

import { useState } from "react"
import "./Home.css"
import { MapPin, Shield, Clock, CreditCard, X, Calendar, Users, BarChart, Award, CheckCircle } from "lucide-react"
import parkImage from "../../assets/parqueaderoHome.avif"
import parkiImage from "../../assets/parqueaderoHome2.avif"

const Home = () => {
  const [showModal, setShowModal] = useState(false)

  const openModal = () => setShowModal(true)
  const closeModal = () => setShowModal(false)

  return (
    <div className="hom-container">
      {/* Hero Section */}
      <div className="hom-hero-section">
        <div className="hom-hero-content">
          <h1>Bienvenido a Parking Club</h1>
          <p className="hom-hero-subtitle">La forma más inteligente de gestionar tu estacionamiento</p>
          <div className="hom-cta-buttons">
            <button className="hom-btn-secondary" onClick={openModal}>
              Conocer más
            </button>
          </div>
        </div>
        <div className="hom-hero-image">
          <img src={parkImage} alt="Estacionamiento moderno" />
        </div>
      </div>

      {/* Features Section */}
      <div className="hom-features-section">
        <h2>¿Por qué elegir Parking Club?</h2>
        <div className="hom-features-grid">
          <div className="hom-feature-card">
            <div className="hom-feature-icon">
              <MapPin size={24} />
            </div>
            <h3>Ubicación estratégica</h3>
            <p>Estacionamientos ubicados en puntos clave de la ciudad para tu comodidad.</p>
          </div>

          <div className="hom-feature-card">
            <div className="hom-feature-icon">
              <Shield size={24} />
            </div>
            <h3>Seguridad garantizada</h3>
            <p>Tu informacion es importante para nosotros, Nuestro sistema de seguridad es avanzados para tu tranquilidad.</p>
          </div>

          <div className="hom-feature-card">
            <div className="hom-feature-icon">
              <Clock size={24} />
            </div>
            <h3>Disponibilidad 24/7</h3>
            <p>Accede a nuestros servicios en cualquier momento del día o la noche.</p>
          </div>

          <div className="hom-feature-card">
            <div className="hom-feature-icon">
              <CreditCard size={24} />
            </div>
            <h3>Pagos flexibles</h3>
            <p>Múltiples métodos de pago para facilitar tu experiencia.</p>
          </div>
        </div>
      </div>

      {/* Stats Section */}
      <div className="hom-stats-section">
        <div className="hom-stat-item">
          <h2>50+</h2>
          <p>Estacionamientos</p>
        </div>
        <div className="hom-stat-item">
          <h2>10,000+</h2>
          <p>Clientes satisfechos</p>
        </div>
        <div className="hom-stat-item">
          <h2>24/7</h2>
          <p>Soporte al cliente</p>
        </div>
        <div className="hom-stat-item">
          <h2>99.9%</h2>
          <p>Seguridad garantizada</p>
        </div>
      </div>

      {/* Modal */}
      {showModal && (
        <div className="hom-modal-overlay">
          <div className="hom-modal-container">
            <button className="hom-modal-close" onClick={closeModal}>
              <X size={24} />
            </button>

            <div className="hom-modal-content">
              <div className="hom-modal-header">
                <h2>Sobre Parking Club</h2>
              </div>

              <div className="hom-modal-body">
                <div className="hom-modal-image">
                  <img src={parkiImage} alt="Parking Club" />
                </div>

                <div className="hom-modal-text">
                  <h3>Nuestra Historia</h3>
                  <p>
                    Parking Club nació en 2025 con una visión revolucionaria: conectar a propietarios de estacionamientos
                    con conductores que necesitan un lugar seguro para aparcar. Desarrollada por un equipo de expertos
                    en tecnología y movilidad urbana, nuestra plataforma ha transformado la manera en que las personas
                    encuentran y gestionan espacios de estacionamiento.
                  </p>

                  <div className="hom-modal-features">
                    <div className="hom-modal-feature">
                      <Calendar className="hom-modal-feature-icon" />
                      <div>
                        <h4>Desarrollado en 2025</h4>
                        <p>Utilizando las tecnologías más avanzadas del mercado</p>
                      </div>
                    </div>

                    <div className="hom-modal-feature">
                      <Users className="hom-modal-feature-icon" />
                      <div>
                        <h4>Conectando personas</h4>
                        <p>Más de 500 propietarios de estacionamientos y 50,000 usuarios activos</p>
                      </div>
                    </div>

                    <div className="hom-modal-feature">
                      <BarChart className="hom-modal-feature-icon" />
                      <div>
                        <h4>Control de ingresos</h4>
                        <p>Herramientas avanzadas para que los propietarios maximicen sus ganancias</p>
                      </div>
                    </div>
                  </div>

                  <div className="hom-modal-commitment">
                    <h3>Nuestro Compromiso</h3>
                    <p>
                      En Parking Club nos comprometemos a ofrecer una solución duradera. Nuestra plataforma cuenta con
                      soporte garantizado por los próximos 10 años, asegurando actualizaciones constantes y mejoras en la
                      experiencia de usuario.
                    </p>

                    <div className="hom-modal-badges">
                      <div className="hom-modal-badge">
                        <Award />
                        <span>Premiado como la mejor app de estacionamiento 2025</span>
                      </div>
                      <div className="hom-modal-badge">
                        <CheckCircle />
                        <span>Soporte garantizado hasta 2035</span>
                      </div>
                    </div>
                  </div>

                  <div className="hom-modal-quote">
                    <blockquote>
                      "Parking Club ha revolucionado la forma en que gestionamos nuestros estacionamientos. Nuestros
                      ingresos han aumentado un 35% desde que comenzamos a usar la plataforma."
                    </blockquote>
                    <cite>— Marco Cueva, Propietario de Red de Estacionamientos</cite>
                  </div>
                </div>
              </div>

              <div className="hom-modal-footer">
                <button className="hom-btn-primary" onClick={closeModal}>
                  Comenzar ahora
                </button>
              </div>
            </div>
          </div>
        </div>
      )}
    </div>
  )
}

export default Home
